import type { WorkflowProfile } from '@/lib/workflowTemplates';
import { getAiHoningPrompt, getBuildGuidance } from '@/lib/workflowTemplates';
import type { Language } from '@/i18n/translations';

/**
 * Transient, per-workflow layer. This is the only volatile part of the system
 * prompt — everything else (BASE/LANGUAGE/PERSONA/EXP/ROLE/USECASE/INTERESTS)
 * stays stable for the given profile and can be cached.
 *
 * We reuse the existing workflowTemplates helpers so q1/q2-specific narrow-
 * downs remain the source of truth.
 */
export function buildTransientLayer(
  workflowProfile: WorkflowProfile | null,
  lang: Language,
): string {
  if (!workflowProfile) return '';
  const { templateId, q1, q2 } = workflowProfile;
  if (!templateId) return '';

  const honing = getAiHoningPrompt(templateId, q1, q2);
  const guidance = getBuildGuidance(templateId, q1, q2);
  if (!honing && !guidance) return '';

  const header = lang === 'sv'
    ? '--- Workflow-specifik kontext ---'
    : '--- Workflow-specific context ---';
  return [header, honing, guidance].filter(Boolean).join('\n\n');
}
